import { render, staticRenderFns } from "./BrowseDefault.vue?vue&type=template&id=ecb91452&scoped=true"
import script from "./BrowseDefault.vue?vue&type=script&lang=js"
export * from "./BrowseDefault.vue?vue&type=script&lang=js"
import style0 from "./BrowseDefault.vue?vue&type=style&index=0&id=ecb91452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb91452",
  null
  
)

export default component.exports